import React from 'react';
import { View } from 'react-native';
import StyleSheet from 'react-native-media-query';
import { getEnvValue } from '../../../Helper/env';

import useMealPlan from '../../../Hooks/useMealPlan';
import {
  ConditionalMealPlanHint,
  HintKey,
} from '../../../Screens/Store/MealPlanHint';
import ThemeColor from '../../../Theme/colors';
import ThemeStyle from '../../../Theme/styles';
import BreakPoints from '../../../Theme/styles/breakpoints';

import ItemCardLarge from '../../Card/ItemLarge';

const RAZZLE_BUILD_MODE = getEnvValue('RAZZLE_BUILD_MODE');
const isBranded = RAZZLE_BUILD_MODE === 'branded';
const Section = ({
  isPreview,
  isResult,
  scrollRef,
  section,
  onError,
  onItemPress,
}) => {
  const { isMealPlan } = useMealPlan();

  return (
    <View
      dataSet={{ media: !isResult ? ids.wrapper : ids.resultWrapper }}
      style={!isResult ? styles.wrapper : styles.resultWrapper}
    >
      {section.data.map((item, index) => (
        <View
          key={item.id}
          dataSet={{ media: ids.itemMainWrapper }}
          style={styles.itemMainWrapper}
        >
          <ConditionalMealPlanHint
            enabled={
              isBranded && isMealPlan && section.index === 0 && index === 0
            }
            hintKey={HintKey.FEATURED}
            scrollOffset={60} // fixed tab bar height
            scrollRef={scrollRef}
          >
            <View
              style={[
                ThemeStyle.flex1,
                ThemeStyle.spacingTop,
                ThemeStyle.spacingRight,
                ThemeStyle.pageBackground,
                { borderRadius: 10 },
              ]}
            >
              <ItemCardLarge
                {...item}
                isPreview={isPreview}
                isMealPlan={isMealPlan}
                onError={onError}
                onPress={() => onItemPress(item)}
              />
            </View>
          </ConditionalMealPlanHint>
        </View>
      ))}
    </View>
  );
};

const { ids, styles } = StyleSheet.create({
  wrapper: {
    flex: 1,
    marginRight: -20, // to offset the margin right of each item
    [`@media ${BreakPoints.xs}`]: {
      ...ThemeStyle.paddingLeft,
      flexDirection: 'column',
      marginRight: 0,
    },
    [`@media ${BreakPoints.sm}`]: {
      flexDirection: 'column',
    },
    [`@media ${BreakPoints.md}`]: {
      flexDirection: 'column',
    },
    [`@media ${BreakPoints.lg}`]: {
      flexWrap: 'wrap',
      flexDirection: 'row',
    },
    [`@media ${BreakPoints.xl}`]: {
      flexWrap: 'wrap',
      flexDirection: 'row',
    },
    [`@media ${BreakPoints.xxl}`]: {
      flexWrap: 'wrap',
      flexDirection: 'row',
    },
  },
  resultWrapper: {
    flex: 1,
    backgroundColor: ThemeColor.gray300,
    paddingLeft: 20,
    paddingBottom: 20,
    borderRadius: 10,
    [`@media ${BreakPoints.xs}`]: {
      ...ThemeStyle.paddingLeft,
      flexDirection: 'column',
      marginRight: 0,
    },
    [`@media ${BreakPoints.sm}`]: {
      flexDirection: 'column',
    },
    [`@media ${BreakPoints.md}`]: {
      flexDirection: 'column',
    },
    [`@media ${BreakPoints.lg}`]: {
      flexWrap: 'wrap',
      flexDirection: 'row',
    },
    [`@media ${BreakPoints.xl}`]: {
      flexWrap: 'wrap',
      flexDirection: 'row',
    },
    [`@media ${BreakPoints.xxl}`]: {
      flexWrap: 'wrap',
      flexDirection: 'row',
    },
  },
  itemMainWrapper: {
    [`@media ${BreakPoints.xs}`]: {
      width: '100%',
    },
    [`@media ${BreakPoints.sm}`]: {
      width: '100%',
    },
    [`@media ${BreakPoints.md}`]: {
      width: '100%',
    },
    [`@media ${BreakPoints.lg}`]: {
      width: '50%',
    },
    [`@media ${BreakPoints.xl}`]: {
      width: '50%',
    },
    [`@media ${BreakPoints.xxl}`]: {
      width: '50%',
    },
  },
});

export default React.memo(Section);
